import React, { useEffect, useMemo, useState } from "react";
import "../css/style.css";
import { useLocation, useNavigate } from "react-router-dom";

import Header from "../../../master/SideBar";
import Nav from "../../../master/NavBar";
import Master from "../../Master";
import StudentProfileHero from "../components/StudentProfileHero";

import { SweetAlertShow } from "../../../master/Master";
import { fetchStudentBatchFeeDetails, StudentBatchFeeSubjectUpdate } from "../../../../api/StudentDetails";


const formatCurrency = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
    });
};

export default function StudentSubjectsAndFeeUp() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const id = params.get("id") ?? "";
    const batch_n_fees_id = params.get("batch_n_fees_id") ?? "";

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [data, setData] = useState({});
    const navigate = useNavigate();

    const [subjects, setSubjects] = useState([]);

    const [selectedSubjects, setSelectedSubjects] = useState([]);

    const [feeDetails, setFeeDetails] = useState([]);

    const [batchFees, setBatchFees] = useState([]);

    const [newFee, setNewFee] = useState({
        fee_type: "",
        actual_amount: 0,
        final_amount: "",
        discount: 0,
    });
    const [deletedFeeIds, setDeletedFeeIds] = useState([]);
    const [discountRemark, setDiscountRemark] = useState("");
    const hasNewDiscount = feeDetails.some(
        fee =>
            (fee.id == null || fee.id > 999999) &&
            Number(fee.discount) > 0
    );

    const getData = async () => {

        setLoading(true);

        try {

            const response = await fetchStudentBatchFeeDetails(batch_n_fees_id);

            if (response.data.status) {

                const d = response.data.data;

                setData(d);

                setSubjects(d.course?.subjects_data || []);

                setFeeDetails(d.student_fee_details || []);

                setBatchFees(d.batch?.fee_details || []);

                /* Selected Subjects */

                let selected = [];

                try {

                    if (d.subjects) {

                        const parsedSubjects = Array.isArray(d.subjects)
                            ? d.subjects
                            : JSON.parse(d.subjects);

                        selected = parsedSubjects.map((item) => {

                            // Old Format
                            if (typeof item === "string" && item.trim().startsWith("{")) {
                                return Number(JSON.parse(item).id);
                            }

                            // New Format (["24","25"])
                            return Number(item);

                        }).filter(id => !isNaN(id));

                    }

                } catch (e) {

                    console.error("Subject Parse Error:", e);
                    selected = [];

                }

                setSelectedSubjects(selected);

            } else {

                SweetAlertShow(
                    "info",
                    "Warning",
                    response.data.message
                );

            }

        } catch (error) {

            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error.message
            );

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        if (batch_n_fees_id) {

            getData();

        }

    }, [batch_n_fees_id]);

    /* -----------------------------
        Subject Checkbox
    ------------------------------ */

    const handleSubject = (subjectId) => {

        if (selectedSubjects.includes(subjectId)) {

            setSelectedSubjects(
                selectedSubjects.filter(id => id !== subjectId)
            );

        } else {

            setSelectedSubjects([
                ...selectedSubjects,
                subjectId
            ]);

        }

    };

    /* -----------------------------
        Fee Update
    ------------------------------ */

    // const updateFee = (index, key, value) => {

    //     const temp = [...feeDetails];

    //     temp[index][key] = value;

    //     temp[index].final_amount =
    //         Number(temp[index].actual_amount || 0) -
    //         Number(temp[index].discount || 0);

    //     setFeeDetails(temp);

    // };

    const updateFee = (index, key, value) => {

        const temp = [...feeDetails];

        let inputValue = Number(value);

        if (key === "discount") {

            const actualAmount = Number(temp[index].actual_amount || 0);

            if (inputValue < 0) {
                inputValue = 0;
            }

            if (inputValue > actualAmount) {

                inputValue = actualAmount;

                SweetAlertShow(
                    "warning",
                    "Warning",
                    "Discount cannot be greater than Fee Amount."
                );
            }
        }

        temp[index][key] = inputValue;

        temp[index].final_amount =
            Number(temp[index].actual_amount) -
            Number(temp[index].discount);

        temp[index].due_amount =
            Number(temp[index].final_amount) -
            Number(temp[index].paid_amount || 0);

        setFeeDetails(temp);
    };

    /* -----------------------------
        Delete Fee
    ------------------------------ */

    const removeFee = (index) => {

        const fee = feeDetails[index];

        if (fee.id && fee.id < 999999) {
            setDeletedFeeIds(prev => [...prev, fee.id]);
        }

        setFeeDetails(prev => prev.filter((_, i) => i !== index));
    };

    /* -----------------------------
        Remaining Fees
    ------------------------------ */

    const remainingFees = batchFees.filter(batchFee =>

        !feeDetails.some(studentFee =>

            studentFee.fee_type === batchFee.fee_type

        )

    );

    /* -----------------------------
        Total
    ------------------------------ */

    const total = useMemo(() => {

        return feeDetails.reduce(

            (sum, fee) =>

                sum + Number(fee.actual_amount || 0),

            0

        );

    }, [feeDetails]);

    const discount = useMemo(() => {

        return feeDetails.reduce(

            (sum, fee) =>

                sum + Number(fee.discount || 0),

            0

        );

    }, [feeDetails]);

    const final = useMemo(() => {

        return total - discount;

    }, [total, discount]);



    const handleSubmit = async (e) => {
        e.preventDefault();

        const hasPreviousSessionFeeDiscount = feeDetails.some(
            (fee) =>
                fee.fee_type === "Previous Session Fees" &&
                Number(fee.discount || 0) > 0
        );

        if (!hasPreviousSessionFeeDiscount && selectedSubjects.length === 0) {
            SweetAlertShow(
                "warning",
                "Warning",
                "Please select at least one subject."
            );
            return;
        }
        setSaving(true);

        const payload = {
            student_id: id ?? null,
            batch_id: data.batch?.id ?? null,
            student_batch_n_fee_id: batch_n_fees_id ?? null,

            subjects: selectedSubjects,
            discount_remark: discountRemark,

            id: [],
            fee_type: [],
            actual_amount: [],
            final_amount: [],
        };

        feeDetails.forEach((fee) => {
            payload.id.push(
                fee.id && fee.id < 999999 ? fee.id : null
            );

            payload.fee_type.push(fee.fee_type);
            payload.actual_amount.push(Number(fee.actual_amount));
            payload.final_amount.push(Number(fee.final_amount));
        });

        try {

            const response = await StudentBatchFeeSubjectUpdate(payload);

            if (response.data.status) {

                await SweetAlertShow(
                    "success",
                    "Success",
                    response.data.message
                );

                navigate(-1);

            } else {

                SweetAlertShow(
                    "error",
                    "Error",
                    response.data.message
                );


            }

        } catch (error) {

            console.error(error);

            SweetAlertShow(
                "error",
                "Error",
                "Something went wrong. Please try again."
            );
            setSaving(false);
        }
    };



    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">

                <Header />

                <div className="layout-page">

                    <Nav />

                    <div className="content-wrapper">

                        <div className="container-fluid container-p-y">

                            <div className="row g-2">

                                <Master />

                                <div className="col-12">

                                    <StudentProfileHero id={id} />

                                    {loading ? (

                                        <div className="d-flex flex-column align-items-center justify-content-center py-5 mt-3">
                                            <div className="spinner-border text-primary mb-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <span className="text-muted small">
                                                Loading batch & fee details...
                                            </span>
                                        </div>

                                    ) : (

                                        <form onSubmit={handleSubmit}>



                                            {/* Subjects */}

                                            <div className="card shadow-sm mt-3 border-0">

                                                <div className="card-header d-flex justify-content-between align-items-center bg-white">

                                                    <h6 className="mb-0 d-flex align-items-center">

                                                        <i className="ri-book-2-line me-2 fs-5 text-primary"></i>

                                                        Subjects

                                                    </h6>

                                                    <span className="badge bg-primary rounded-pill px-3 py-2">

                                                        {selectedSubjects.length} / {subjects.length}

                                                        &nbsp;Selected

                                                    </span>

                                                </div>

                                                <div className="card-body">

                                                    <div className="row">

                                                        {subjects.length === 0 && (

                                                            <div className="col-12 text-center text-muted py-4">

                                                                <i className="ri-book-2-line fs-1 d-block mb-2 opacity-50"></i>

                                                                No Subjects Found

                                                            </div>

                                                        )}

                                                        {subjects.map((subject) => {

                                                            const isSelected = selectedSubjects.includes(subject.id);

                                                            return (

                                                                <div
                                                                    className="col-lg-2 col-md-4 col-sm-6 mb-3"
                                                                    key={subject.id}
                                                                >

                                                                    <div
                                                                        className={`border rounded-3 p-3 cursor-pointer h-100 transition-all ${isSelected
                                                                            ? "border-primary bg-opacity-10 shadow-sm"
                                                                            : "bg-light bg-opacity-50"
                                                                            }`}
                                                                        style={{ transition: "all 0.15s ease", cursor: "pointer" }}
                                                                        onClick={() => handleSubject(subject.id)}
                                                                    >

                                                                        <div className="form-check d-flex align-items-start gap-2 mb-0">

                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input mt-1 flex-shrink-0"
                                                                                id={`subject_${subject.id}`}
                                                                                checked={isSelected}
                                                                                onChange={() =>
                                                                                    handleSubject(subject.id)
                                                                                }
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            />

                                                                            <label
                                                                                htmlFor={`subject_${subject.id}`}
                                                                                className="form-check-label w-100"
                                                                                onClick={(e) => e.preventDefault()}
                                                                            >

                                                                                <strong className="d-block">

                                                                                    {subject.name}

                                                                                </strong>

                                                                                <small className="text-muted">

                                                                                    Code: {subject.subject_code}

                                                                                </small>

                                                                            </label>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            );

                                                        })}

                                                    </div>

                                                </div>

                                            </div>

                                            {/* Student Fee Structure */}

                                            <div className="card shadow-sm mt-3 border-0">

                                                <div className="card-header d-flex justify-content-between align-items-center bg-white">

                                                    <h6 className="mb-0 d-flex align-items-center">

                                                        <i className="ri-money-dollar-circle-line me-2 fs-5 text-primary"></i>

                                                        Student Fee Structure

                                                    </h6>

                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#addFeeBox"
                                                    >
                                                        <i className="ri-add-line me-1"></i>

                                                        Add Fee

                                                    </button>

                                                </div>

                                                <div className="table-responsive">

                                                    <table className="table table-bordered align-middle mb-0">

                                                        <thead className="table-light">

                                                            <tr>

                                                                <th width="50">#</th>

                                                                <th>Fee Type</th>

                                                                <th >Amount</th>

                                                                <th >Discount</th>

                                                                <th >Final</th>

                                                                <th >Paid</th>

                                                                <th >Due</th>

                                                                <th className="text-center">Action</th>

                                                            </tr>

                                                        </thead>

                                                        <tbody>

                                                            {feeDetails.length === 0 && (

                                                                <tr>
                                                                    <td colSpan={8} className="text-center text-muted py-4">
                                                                        <i className="ri-file-list-3-line fs-3 d-block mb-1 opacity-50"></i>
                                                                        No fees added yet
                                                                    </td>
                                                                </tr>

                                                            )}

                                                            {feeDetails.map((fee, index) => {

                                                                const canDelete =
                                                                    Number(fee.paid_amount || 0) === 0 &&
                                                                    Number(fee.due_amount || fee.final_amount || 0) ===
                                                                    Number(fee.final_amount || 0);

                                                                return (

                                                                    <tr key={fee.id ?? index}>

                                                                        <td>

                                                                            {index + 1}

                                                                        </td>

                                                                        <td>

                                                                            <strong>

                                                                                {fee.fee_type}

                                                                            </strong>

                                                                        </td>

                                                                        <td>

                                                                            <div className="input-group input-group-sm">
                                                                                <span className="input-group-text">₹</span>
                                                                                <input
                                                                                    type="number" disabled
                                                                                    className="form-control"
                                                                                    value={fee.actual_amount}
                                                                                    onChange={(e) =>
                                                                                        updateFee(
                                                                                            index,
                                                                                            "actual_amount",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>

                                                                        </td>

                                                                        <td>

                                                                            <div className="input-group input-group-sm">
                                                                                <span className="input-group-text">₹</span>
                                                                                <input
                                                                                    type="number"
                                                                                    disabled={fee.fee_type === "Registration Fee"}
                                                                                    className="form-control"
                                                                                    value={fee.discount}
                                                                                    onChange={(e) =>
                                                                                        updateFee(
                                                                                            index,
                                                                                            "discount",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>

                                                                        </td>

                                                                        <td>

                                                                            <strong className="text-primary">

                                                                                ₹{formatCurrency(fee.final_amount)}

                                                                            </strong>

                                                                        </td>

                                                                        <td className="text-success fw-medium">

                                                                            ₹{formatCurrency(fee.paid_amount)}

                                                                        </td>

                                                                        <td className="text-danger fw-medium">

                                                                            ₹{formatCurrency(fee.due_amount)}

                                                                        </td>

                                                                        <td className="text-center">

                                                                            {canDelete ? (

                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-danger btn-sm"
                                                                                    title="Remove fee"
                                                                                    onClick={() =>
                                                                                        removeFee(index)
                                                                                    }
                                                                                >

                                                                                    <i className="ri-delete-bin-line"></i>

                                                                                </button>

                                                                            ) : (

                                                                                <span className="badge bg-success">

                                                                                    <i className="ri-lock-line me-1"></i>
                                                                                    Locked

                                                                                </span>

                                                                            )}

                                                                        </td>

                                                                    </tr>

                                                                );

                                                            })}

                                                        </tbody>

                                                    </table>

                                                </div>

                                                {/* Add Fee */}

                                                <div
                                                    className="collapse border-top"
                                                    id="addFeeBox"
                                                >

                                                    <div className="card-body  bg-opacity-50">

                                                        <div className="row g-3">

                                                            <div className="col-md-4">

                                                                <label className="form-label small fw-medium">

                                                                    Fee Type

                                                                </label>

                                                                <select
                                                                    className="form-select"
                                                                    value={newFee.fee_type}
                                                                    onChange={(e) => {

                                                                        const fee = remainingFees.find(
                                                                            item => item.fee_type === e.target.value
                                                                        );

                                                                        setNewFee({
                                                                            fee_type: fee?.fee_type || "",
                                                                            actual_amount: Number(fee?.amount || 0),
                                                                            final_amount: Number(fee?.amount || 0),
                                                                            discount: 0,
                                                                        });

                                                                    }}
                                                                >
                                                                    <option value="">Select Fee</option>

                                                                    {remainingFees.map((fee) => (
                                                                        <option key={fee.id} value={fee.fee_type}>
                                                                            {fee.fee_type}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                {remainingFees.length === 0 && (
                                                                    <small className="text-muted">
                                                                        All batch fees already added
                                                                    </small>
                                                                )}

                                                            </div>

                                                            <div className="col-md-3">

                                                                <label className="form-label">

                                                                    Final Fee

                                                                </label>

                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={newFee.final_amount}
                                                                    disabled={!newFee.fee_type}
                                                                    onChange={(e) => {

                                                                        const finalAmount = Number(e.target.value);

                                                                        setNewFee({

                                                                            ...newFee,

                                                                            final_amount: finalAmount,

                                                                            discount:
                                                                                Number(newFee.actual_amount) -
                                                                                finalAmount

                                                                        });

                                                                    }}
                                                                />

                                                            </div>


                                                            <div className="col-md-2">

                                                                <label className="form-label">

                                                                    Discount

                                                                </label>

                                                                <input
                                                                    disabled
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={newFee.discount}
                                                                    readOnly
                                                                />

                                                            </div>

                                                            <div className="col-md-1 d-flex align-items-end">

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary w-100"
                                                                    disabled={!newFee.fee_type}
                                                                    onClick={() => {

                                                                        if (!newFee.fee_type) return;

                                                                        setFeeDetails([
                                                                            ...feeDetails,
                                                                            {
                                                                                id: Date.now(),
                                                                                fee_type: newFee.fee_type,
                                                                                actual_amount: newFee.actual_amount,
                                                                                discount: newFee.discount,
                                                                                final_amount: newFee.final_amount,
                                                                                paid_amount: 0,
                                                                                due_amount: newFee.final_amount,
                                                                            }
                                                                        ]);

                                                                        setNewFee({
                                                                            fee_type: "",
                                                                            actual_amount: 0,
                                                                            final_amount: "",
                                                                            discount: 0,
                                                                        });

                                                                    }}
                                                                >

                                                                    <i className="ri-add-circle-line me-1"></i>

                                                                    Add

                                                                </button>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            {/* Summary */}

                                            <div className="card shadow-sm mt-3 border-0 bg-light bg-opacity-50">

                                                <div className="row text-center g-3">

                                                    <div className="col-md-4">

                                                        <div className="p-2">
                                                            <small className="text-muted text-uppercase d-block mb-1">
                                                                <i className="ri-wallet-3-line me-1"></i>
                                                                Total Amount
                                                            </small>

                                                            <h4 className="fw-bold mb-0">

                                                                ₹{formatCurrency(total)}

                                                            </h4>
                                                        </div>

                                                    </div>

                                                    <div className="col-md-4">

                                                        <div className="p-2">
                                                            <small className="text-muted text-uppercase d-block mb-1">
                                                                <i className="ri-price-tag-3-line me-1"></i>
                                                                Total Discount
                                                            </small>

                                                            <h4 className="fw-bold text-warning mb-0">

                                                                ₹{formatCurrency(discount)}

                                                            </h4>
                                                        </div>

                                                    </div>

                                                    <div className="col-md-4">

                                                        <div className="p-2 border-start-md">
                                                            <small className="text-muted text-uppercase d-block mb-1">
                                                                <i className="ri-checkbox-circle-line me-1"></i>
                                                                Final Amount
                                                            </small>

                                                            <h4 className="fw-bold text-primary mb-0">

                                                                ₹{formatCurrency(final)}

                                                            </h4>
                                                        </div>

                                                    </div>

                                                </div>


                                            </div>

                                            {/* Action Buttons */}

                                            <div className="card shadow-sm mt-3 border-0">
                                                <div className="card-body">

                                                    {hasNewDiscount && (
                                                        <div className="card shadow-sm  border-0 mb-4">

                                                            <div className="card-header">
                                                                <h6 className="mb-0">
                                                                    <i className="ri-chat-1-line me-2"></i>
                                                                    Discount Remark
                                                                </h6>
                                                            </div>

                                                            <div className="card-body">

                                                                <textarea
                                                                    className="form-control"
                                                                    rows="1"
                                                                    placeholder="Enter Discount Remark"
                                                                    value={discountRemark}
                                                                    onChange={(e) => setDiscountRemark(e.target.value)}
                                                                />

                                                            </div>

                                                        </div>
                                                    )}

                                                    <div className="d-flex justify-content-end gap-2 ">





                                                        <button
                                                            type="button"
                                                            className="btn btn-light"
                                                            onClick={() => window.history.back()}
                                                        >
                                                            <i className="ri-arrow-left-line me-1"></i>
                                                            Cancel
                                                        </button>

                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary"
                                                            disabled={saving}
                                                        >
                                                            {saving ? (
                                                                <>
                                                                    <span
                                                                        className="spinner-border spinner-border-sm me-2"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    ></span>
                                                                    Saving...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="ri-save-3-line me-1"></i>
                                                                    Save Changes
                                                                </>
                                                            )}
                                                        </button>

                                                    </div>

                                                </div>
                                            </div>

                                        </form>

                                    )}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
